import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "cookie-consent";

declare global {
  interface Window {
    loadGA4?: () => void;
  }
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptEssential = () => {
    localStorage.setItem(CONSENT_KEY, "essential");
    setVisible(false);
  };

  const handleAcceptAll = () => {
    localStorage.setItem(CONSENT_KEY, "all");
    window.loadGA4?.();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in-up">
      <div className="mx-auto max-w-4xl px-4 pb-4">
        <div className="rounded-xl border bg-card p-4 shadow-lg sm:p-5">
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                We value your privacy
              </p>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
                We use essential cookies for security (Cloudflare Turnstile) and preferences. You can also accept analytics cookies (Google Analytics) to help us improve the site. No marketing cookies are used.{" "}
                <Link to="/cookie-policy" className="text-primary hover:underline">
                  Learn more
                </Link>
              </p>
            </div>
          </div>

          <div className="mt-3 flex items-center justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleAcceptEssential}
              className="text-xs"
            >
              Essential Only
            </Button>
            <Button size="sm" onClick={handleAcceptAll} className="text-xs">
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
